import React from 'react';

import Dialog from 'components/mui/Dialog';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import IconButton from '@mui/material/IconButton';

interface AccountDetailItem {
  paymentsType: string;
  account: string;
  routing: string;
}

interface AccountDetailData {
  name: string;
  details: AccountDetailItem[];
}

interface DialogAccountDetailsProps {
  onClose: () => void;
  data: AccountDetailData;
}

const DialogAccountDetails: React.FC<DialogAccountDetailsProps> = ({ onClose, data }) => {
  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
    } catch (err) {
      console.error('Failed to copy', err);
    }
  };

  return (
    <Dialog
      open
      onClose={onClose}
      title={data.name}
      withCloseBtn
      withActions={false}
      draggable={false}
      okText={null}
      cancelText={null}
      onOk={null}
      okBtnProps={null}
    >
      {data.details.map((item) => (
        <Box key={item.paymentsType} sx={{ mb: 2, p: 1, borderBottom: '1px solid #eee' }}>
          <Typography variant="subtitle2">{item.paymentsType}</Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="body2">Account: {item.account}</Typography>
            <IconButton size="small" onClick={() => copyToClipboard(item.account)}>
              <ContentCopyIcon fontSize="inherit" />
            </IconButton>
          </Stack>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="body2">Routing: {item.routing}</Typography>
            <IconButton size="small" onClick={() => copyToClipboard(item.routing)}>
              <ContentCopyIcon fontSize="inherit" />
            </IconButton>
          </Stack>
        </Box>
      ))}
    </Dialog>
  );
};

export default DialogAccountDetails;
